(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["questionnaire-sticky"]) return;
  try {
    
  if(!customElements.get('sc-questionnaire-sticky')){
    customElements.define('sc-questionnaire-sticky',class extends HTMLElement{
      connectedCallback(){
        this.controller=new AbortController();
        const signal=this.controller.signal;
        const key='sc-survey-sticky-dismissed-v1';
        const editor=this.dataset.editor==='true';
        const showAlways=this.dataset.uniqueParticipation==='true';
        const readCookie=n=>document.cookie.split('; ').find(c=>c.indexOf(n+'=')===0)?.split('=')[1];
        const writeCookie=n=>{try{document.cookie=n+'=1; path=/; max-age=31536000; SameSite=Lax'}catch(e){}};
        if(new URLSearchParams(location.search).get('sc_reset')==='1'){
          try{localStorage.removeItem(key);localStorage.removeItem('shapers-questionnaire-completed-questionnaire_10');sessionStorage.removeItem(key)}catch(e){}
          try{document.cookie=key+'=; path=/; max-age=0'}catch(e){}
        }
        let dismissed=false;
        try{dismissed=localStorage.getItem(key)==='1'}catch(e){}
        if(!dismissed&&readCookie(key)==='1')dismissed=true;
        this.header=document.querySelector('.header-section header');
        this.syncPosition=()=>{
          this.until=performance.now()+700;
          if(!this.frame)this.frame=requestAnimationFrame(this.trackPosition);
        };
        this.trackPosition=()=>{
          this.frame=0;
          if(!this.isConnected||this.hidden)return;
          const bottom=Math.max(0,this.header?.getBoundingClientRect().bottom||0);
          this.style.setProperty('--sc-header-bottom',bottom+'px');
          if(performance.now()<this.until)this.frame=requestAnimationFrame(this.trackPosition);
        };
        let completed=false;
        try{completed=localStorage.getItem('shapers-questionnaire-completed-questionnaire_10')==='1'}catch(e){}
        this.hidden=(dismissed||completed)&&!editor&&!showAlways;
        /* SC : écran d'arrivée allégé, la languette n'apparaît qu'après un premier défilement */
        if(!this.hidden&&!editor&&!showAlways&&window.scrollY<320){
          this.hidden=true;
          const reveal=()=>{if(window.scrollY>=320){window.removeEventListener('scroll',reveal);this.hidden=false;this.syncPosition&&this.syncPosition();}};
          window.addEventListener('scroll',reveal,{passive:true,signal});
        }
        const hideCompleted=()=>{if(!editor&&!showAlways){this.hidden=true;try{localStorage.setItem(key,'1')}catch(e){}writeCookie(key);}};
        window.addEventListener('sc-questionnaire-completed',hideCompleted,{signal});
        window.addEventListener('storage',e=>{if(e.key==='shapers-questionnaire-completed-questionnaire_10'&&e.newValue==='1')hideCompleted()},{signal});
        this.syncPosition();
        window.addEventListener('scroll',this.syncPosition,{passive:true,signal});
        window.addEventListener('resize',this.syncPosition,{passive:true,signal});
        window.addEventListener('pageshow',this.syncPosition,{signal});
        this.resizeObserver=new ResizeObserver(this.syncPosition);
        this.mutationObserver=new MutationObserver(this.syncPosition);
        if(this.header){
          this.resizeObserver.observe(this.header);
          this.mutationObserver.observe(this.header.parentElement,{attributes:true,attributeFilter:['class','style']});
          this.header.parentElement.addEventListener('transitionrun',this.syncPosition,{signal});
        }
        const link=this.querySelector('a');
        const url=new URL(link.href,location.origin);
        url.searchParams.set('sc_origin',location.pathname);
        const preview=new URLSearchParams(location.search).get('preview_theme_id');
        if(preview&&/^\d+$/.test(preview))url.searchParams.set('preview_theme_id',preview);
        link.href=url.href;
        this.querySelector('button').addEventListener('click',()=>{
          this.hidden=true;
          if(!editor){try{localStorage.setItem(key,'1')}catch(e){}writeCookie(key);}
        },{signal});
      }
      disconnectedCallback(){
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame=0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
